export default "__VITE_ASSET__CaaIjBpV__"